import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import classNames from "classnames";

import { Input, RoundButton } from "@mwi/ui";

import { createConversation, sendMessage } from "slices/messages";
import { RootState } from "store";

const MessageInput = ({
  conversationId,
}: {
  conversationId?: string;
}): JSX.Element => {
  const dispatch = useDispatch();
  const { register, handleSubmit, watch, reset } = useForm<{
    newMessageText: string;
  }>();

  const { practiceId, draftConversation } = useSelector((state: RootState) => ({
    practiceId: state.auth.registered_site?.id,
    draftConversation: state.messages.draftConversation,
  }));

  const handleOnSubmit = (data: { newMessageText: string }) => {
    if (
      draftConversation &&
      draftConversation.summary?.title &&
      data.newMessageText
    ) {
      dispatch(
        createConversation({
          to: practiceId!,
          title: draftConversation.summary.title,
          sourceId: draftConversation.sourceId!,
          message: data.newMessageText,
          ...(draftConversation.summary.pet && {
            pet: draftConversation.summary.pet,
          }),
        }),
      );
    }

    if (conversationId && data.newMessageText) {
      dispatch(
        sendMessage({
          conversationId,
          message: data.newMessageText,
        }),
      );

      reset({ newMessageText: "" });
    }
  };

  return (
    <div
      className={classNames(
        "flex-grow-0 border-t bg-white border-grey-light py-4 px-4 mt-6",
      )}
    >
      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className="flex flex-row justify-between items-center gap-2">
          <Input
            data-test-id="Conversation_NewMessage-input"
            className="flex-grow"
            {...register("newMessageText")}
            autoComplete="off"
            placeHolder="Message"
          />
          <RoundButton
            data-test-id="Conversation_NewMessage-Submit-button"
            className="flex-shrink-0"
            type="submit"
            variant="grey"
            disabled={!watch("newMessageText")}
          />
        </div>
      </form>
    </div>
  );
};

export default MessageInput;
